// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"395":"f61c0537","724":"f61c0537"}[chunkId] + ".chunk.css";
};